import type { AdminViewDefinition } from "../../../components/admin-components.js";
import { installationsListView } from "../directory/installation-directory-pages.js";
import { storeOverviewView } from "../store-detail/store-detail-pages.js";

export const installationStateAdminViews: AdminViewDefinition[] = [
  emptyInstallationsView(),
  storeNotFoundView(),
  uninstalledStoreHistoricalView(),
  noSearchResultsView(),
];

function emptyInstallationsView(): AdminViewDefinition {
  return {
    ...installationsListView(),
    id: "empty-installations",
    state: {
      title: "No  stores installed yet",
      description: "Installations will appear here after the first  OAuth callback completes.",
      tone: "blue",
      actions: [
        { label: "View installation runbook", routeId: "installations-list" },
        { label: "Refresh", variant: "primary", routeId: "installations-list" },
      ],
    },
    tables: [],
  };
}

function storeNotFoundView(): AdminViewDefinition {
  return {
    id: "store-not-found",
    navId: "stores",
    title: "Store not found",
    description: "The requested store is missing, deleted, or outside your authorized environment.",
    state: {
      title: "Store not found",
      description: "Check the store hash and environment before trying again.",
      tone: "red",
      actions: [
        { label: "Back to installations", variant: "primary", routeId: "installations-list" },
      ],
    },
  };
}

function uninstalledStoreHistoricalView(): AdminViewDefinition {
  return {
    ...storeOverviewView(),
    id: "uninstalled-store-historical",
    title: "Historical store",
    description:
      "Uninstalled store. Historical operational records remain available according to retention policy.",
    callouts: [
      {
        title: "Historical store",
        body: "New support actions are disabled. Audit, notes, and retention records remain readable.",
        tone: "orange",
      },
    ],
    actions: [{ label: "Back to uninstalled stores", routeId: "uninstalled-stores" }],
  };
}

function noSearchResultsView(): AdminViewDefinition {
  return {
    ...installationsListView(),
    id: "no-search-results",
    state: {
      title: "No stores match these filters",
      description: "Clear filters or save this empty view for later investigation.",
      tone: "gray",
      actions: [
        { label: "Clear filters", variant: "primary", routeId: "installations-list" },
        { label: "Save current view" },
      ],
    },
    tables: [],
  };
}
